// Client-side JS called when a page is rendered

var app = require('./index');
var helpers = require('../render-fns-helpers');
//voice range selector
var RangeSelector = require('../../ui/voiceRangeSelector/RangeSelector');

log = console.log.bind(console);

app.on('render:chicago-prize-composers', function(ctx) {
	//composer bios
	var biosByComposerId = {};
	app.model.get('_page.composers').forEach(function(composer) {
		biosByComposerId[composer.id] = composer.bio;
	});
	
	$('.bio-link').tooltip({
		html: true,
		title: function() {
			var bio = biosByComposerId[ $(this).data('composerId') ];
			return stripTags(bio);
		}
	});
});

app.on('render:temp', function(ctx) {
	log('render temp')
});

app.on('render:home', function(ctx) {
	var model = app.model;

	//renderSongsCounter();
	
	//Musical Theater Factory popover
	$('#mtf-popover-link').popover({
		html: true,
		content: function() {
			return $('#mtf-popover').html()	
		},
		container: '#mtf-popover-container'
	});
	
	//composer bios
	var biosByComposerId = {};
	model.get('_page.featuredComposers').forEach(function(composer) {
		biosByComposerId[composer.id] = composer.bio;
	});
	$('.featured-composer-bio-link').tooltip({
		html: true,
		title: function() {
			var bio = biosByComposerId[ $(this).data('composerId') ];
			return stripTags(bio);
		}
	});
	
	//Worldcat
	$('#lnk-worldcat-details').popover({
		html: true
	  , content: $('#worldcat-details').html()
	});
	
	//Tooltips
	$('[data-toggle="tooltip"]').tooltip({
		html: true,
		title: function() {
			//TODO - these shouldn't be hard-coded
			switch ($(this).attr('name')) {
			    case 'bipoc':
			        return "Includes AIPAP (Asian, Indian, Pacific Islander), Black, Indigenous, Latine & MENASA (Middle-East, North African, South Asian) creators.";
				case 'voiceRange':
					return "The lowest and highest vocal notes in the piece. This is often called the <i>tessitura</i> in Italian. For our system, C4=Middle C. The notes in the same octave as Middle C are C#4-B4. The next octave begins with C5 and continues up to the highest note on the piano, C8. The octave below middle C range is C3-B3 etc. and continues downward to the lowest note on the piano, A0.";
				case 'accompanistDifficulty':
					return "1 (Easiest) to 5 (Most Difficult). (Levels 1-3 are acceptable songs to bring to audition for a salaried position). For more details on each level, see the \"difficulty for accompanist\" entries on the glossary page.";
				case 'popularity':
					return 'Choose songs by popularity. This allows you to seek a out well-known and -loved song, a rare finds that will stand out or something in between.';
			}
		}
	});

	//log(model.get('_session.songSearch.composerIds'))

	//auto-suggest for composers/lyricists
	if ($('#composers').length) helpers.initComposersOrLyricistsField(model.get('_session.songSearch.composerIds'), 'composers', false, true, model);
	helpers.initComposersOrLyricistsField(model.get('_session.songSearch.lyricistIds'), 'lyricists', false, true, model);

	//auto-suggest field for entering tags in search form
	var config = helpers.getTagAutoSuggestConfig(model, 'tags', false, true);
	//allow user to do search by pressing enter
	//"If set to true the dropdown is opened when the user presses the enter key and Select2 is closed."
	config.openOnEnter = false;

	var tags = model.get('_session.songSearch.tags');
	$('#tags').val(tags).select2(config);

	//Since tags are retrieved via ajax, we manually construct the HTML here
	//TODO find a more elegant way of doing this

	//Initialize the tag list popover

	if (!$('#tag-list-popover-container').length) {
		$('body').prepend($('<div id="tag-list-popover-container"><div id="tag-definition-container"></div></div>'));
		//$('body').prepend($('<div id="tag-list-popover-container"></div>'));
	}

	var $tagList = $('#tag-list-popover ul');
	$('#lnk-all-tags').popover({
		html: true
	  , container: '#tag-list-popover-container'
      , content: function () {
			if ($tagList.html()=='') {
				var tags = model.get('_page.existingTags');
                var html = '';
                tags.forEach(function(tag) {
                    if (tag) { //just in case of empty tag in db somehow
                        html += '<li><a href="javascript:;" class="add-tag-link">'+tag+'</a></li>';
                    }
                });
                $tagList.html(html);
			}
			return $tagList.html();
        }
    });
	closePopoversOnClickOutside();

    $('#lnk-all-tags').on('shown.bs.popover', function(e) {
        var tagDefs = model.get('_page.tagDefinitions');
        //Tooltips to show glossary entries for tags
        $('.add-tag-link').tooltip({
            html: true,
            //trigger: 'click',
            container: '#tag-definition-container',
            placement: 'left',
            title: function() {
				var def;
				var thisTag = $(this).html();
				for (var tag in tagDefs) {
					if (tag.toLowerCase() == thisTag.toLowerCase()) {
						def = tagDefs[thisTag];
						break;
					}
				}
                return def;
            }
        });
    });

    //add tag to tag auto-suggest box
    $('#tag-list-popover-container').on('click', '.add-tag-link', function(e) {
        var tag = $(this).html();
        var currentTags = $('#tags').select2('val');
        if (currentTags.indexOf(tag) == -1)
            $('#tags').select2('val', currentTags.concat(tag));
    });

    //voice range display
    var range = model.get('_session.songSearch.voiceRange');
    if (range) {
        model.set('_page.voiceRangeDisplayString', RangeSelector.getRangeDisplayString(range.lowestNote, range.highestNote));
    }
	
	//testimonials - truncate
	$('.truncate').collapser({
		mode: 'words',
		truncate: 10,
		showText: 'Read&nbsp;more &raquo;',
		hideText: '&laquo; Show less'
	})
	.show();
	
	/*
	//Composer bio popover
	$('.composer-bio-link').attr('href', 'javascript:;');
	
	closePopoversOnClickOutside();
	
	$('#mtf-popover-container').popover({
		html: true
	  , selector: '.composer-bio-link'
	  , placement: 'left'
	  , content: function() {
	      return model.get('_page.featuredComposerBios.' + $(this).data('title'));
		}
		//include close button (adapted from http://stackoverflow.com/a/13413660/560114)
		//click handler is below
	  ,	title: function() {
			return '<span class="text-info"><strong>' + $(this).data('title') + '</strong></span>'
				+ '<button type="button" class="close"'
				+ ' data-title="' + $(this).data('title') + '"'
				+ '>&times;</button>';
		}
	})
	.on('shown.bs.popover', function(e) {
		if ($(e.target).parent().attr('id') != 'mtf-popover-container') {
			var width = 350;
			$('#mtf-popover-container .popover').not('#mtf-popover-container > .popover')
				.css({'width': width, 'maxWidth': width});
		}
	})
	//close button
	.on('click', '.close', function(e) {
		e.stopPropagation();
		//$('#mtf-popover-container .popover .popover').hide();
		var $link = $('#mtf-popover-container .composer-bio-link[data-title="' + $(e.target).data('title') + '"]');
		$link.popover('hide');
	});
	
	//close other popovers
	//http://stackoverflow.com/a/24289767/560114
	var $currentPopover = null;
	$('#mtf-popover-container').on("show.bs.popover", function(e){
		var $target = $(e.target);
		if ($currentPopover && ($currentPopover.get(0) != $target.get(0))) {
		  $currentPopover.popover('toggle');
		}
		$currentPopover = $target;
	})
	.on('hidden.bs.popover', function (e) {
		var $target = $(e.target);
		if ($currentPopover && ($currentPopover.get(0) == $target.get(0))) {
		  $currentPopover = null;
		}
	});
	*/
});

//Used for tooltips
//Source: http://phpjs.org/functions/strip_tags/
function stripTags(input, allowed) {
  allowed = (((allowed || '') + '')
    .toLowerCase()
    .match(/<[a-z][a-z0-9]*>/g) || [])
    .join(''); // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
  var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
    commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
  return input.replace(commentsAndPhpTags, '')
    .replace(tags, function($0, $1) {
      return allowed.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 : '';
    });
}

app.on('render:search-results', function(ctx) {
	//When the homepage search form is submitted, the search parameters are saved to the session,
	//but we save the search parameters in the URL to the session here also to account
	//for the case where a user already did a search and then pasted in a link from a friend...
	//when clicking "modify search" you should always get the search that was just in the URL

    //_session.songSearch was updated by the route to contain the search parameters from the current URL
    var search = app.model.get('_session.songSearch');
	
	//dateShowAdded isn't one of the regular search parameters; it's just for the list of recently added shows
	//(although we could potentially add this to the main search form)
	delete search.dateShowCreated;
	
	//TEMP - for Chicago competitoin
	if (app.model.get('_page.isChicagoPrizeSearch')) {
		app.model.del('_session.songSearch');
	}
	else {
		//TODO this should probably be a POST request
		jQuery.get('/save-song-search-to-session?' + 'search=' + encodeURIComponent(JSON.stringify(search)));
		//this gets set by the server, but also needs to be set here, since the homepage can be rendered
		//on either the client or the server
		app.model.set('_session.prevVoiceRangeSearch', search.prevVoiceRange);
	}
	
	$('#createListFromSelectionConfirmationTrigger').popover({
		html: true,
        content: function () {
            return $('#createListFromSelectionConfirmation').html();
        },
        title: function() {
			return $('#createListFromSelectionConfirmation .popover-title').html();
        }
	});
	
	//search for recently added shows
	$('#recentlyAddedDaysSelect').change(function() {
		var songsOrShows = $(this).data('songsOrShows');
		var numDays = $(this).find(':selected').val();
		var search = {};
		search['date' + (songsOrShows == 'songs' ? 'Song': 'Show') + 'Created'] = {
			numDays: parseInt(numDays)
		};
		
		//send the JSON object to the search/songs route
		window.location = '/search/songs?search=' + encodeURIComponent(JSON.stringify(search)) + '&sort=showSortTitle,pageNumbers.start,sortTitle';
	});
	
	//Populate list of song lists that appears on form for adding additional song(s) to an existing song list.
	//TODO: refactor so that hacky app._getSongListsWithStorageLocation() is no longer needed.
	
	//session expiration cleanup; see render:song-lists:view function
	if (!Cookies.get('sharedSongListsSessionStarted')) {
		localStorage.setItem('sharedSongListsThisSession', '{}');
	}
	
	var model = app.model;
	app._getSongListsWithStorageLocation(true).then(function(lists) {
		model.set('_page.songListForm.songLists', lists);
		//Load each of the lists stored in the DB to Derby's model so they can be retrieved
		//synchronously later even if they're not one of the user's own song lists
		//(i.e. a list that was shared with the current user).
		lists.forEach(function(list) {
			if (list._storageLocation == 'db') {
				model.fetch('songLists.' + list.id);
			}
		});
	});
	
	/*
	//Firefox workaround for song lists
	var model = app.model;
	if (navigator.userAgent.indexOf('Firefox') != -1 && determineSongListSaveType(model) == 'session') {
		var songLists = localStorage.getItem('songLists');
		songLists = (songLists ? $.parseJSON(songLists): {});
		var arrSongLists = [];
		for (var id in songLists) {
			list = songLists[id];
			arrSongLists.push(list);
		}
		model.set('_session.songLists', songLists);
		model.set('_page.songListForm.songLists', arrSongLists);
	}
	*/
	
	//$('#createListFromSelectionConfirmation').confirmation();
	//$('#addToSongListForm').modal('show');
});

//returns whether the song list should be saved in the session or in the DB
function determineSongListSaveType(model) {
	//For subscribed users (except institutional limited accounts), save to the DB
	if (model.get('_session.user.isSubscribed') && model.get('_session.institutionalPlanType') != 'singleLimitedAccount') {
		return 'db';
	}
	else return 'session';
}

app.on('render:song-detail', function(ctx) {
	var model = app.model;
	var ExternalLinkClick = require('../data-objects/ExternalLinkClick');

	//avoid spam by not having the full email address listed anywhere, not even in the JS
    var address = 'feedback', domain = 'musicaltheatersongs.com';
    model.set('_page.feedbackEmailAddress', address + '@' + domain);

	//Tooltips
	$('[data-toggle="tooltip"]').tooltip({
		html: true,
		title: function() {
			//TODO store these tooltips in a config file or the DB
			switch ($(this).attr('name')) {
				case 'voiceRange':
					return "The lowest and highest vocal notes in the piece. This is often called the <i>tessitura</i> in Italian. For our system, C4=Middle C. The notes in the same octave as Middle C are C#4-B4. The next octave begins with C5 and continues up to the highest note on the piano, C8. The octave below middle C range is C3-B3 etc. and continues downward to the lowest note on the piano, A0.";
				case 'accompanistDifficulty':
					return "1 (Easiest) to 5 (Most Difficult). (Levels 1-3 are acceptable songs to bring to audition for a salaried position). For more details on each level, see the \"difficulty for accompanist\" entries on the glossary page.";
				case 'pageNumbers':
					return 'These refer to the page numbers in the original printed or hand-written piano/vocal or piano/conductor score. If there is a deviation from this, it will be indicated in the comments. Stand Alone Songs will often have page indications of <span style="white-space: nowrap;">1-1.</span>';
			}			
		}
	});

	$('.lnk-find-recordings-scores').popover({
		html: true,
		content: function () {
            return $(this).next('.popover-content').html();
        }
	});
	
	$('.external-links').on('click', '.popover .external-link', function(e) {
		var $link = $(e.target);
		model.add('externalLinkClicks', new ExternalLinkClick({
			songId: model.get('_page.song.id'),
			linkType: $link.data('linkType'),
			siteId: $link.data('siteId'),
			userId: model.get('_session.userId'),
			subscriptionId: model.get('_session.subscriptionId')
		}));
	});
	
	closePopoversOnClickOutside();

	//Glossary definitions for tags (on hover)

	if (!$('#tag-definition-container').length) {
		$('body').prepend($('<div id="tag-definition-container"></div>'));
	}

	var tagDefs = [];
	jQuery.getJSON('/get-all-tags?includeGlossaryDefinitions=1')
    .done(function(tagDefs) {
	    //Tooltips to show glossary entries for tags
	    $('.tag').tooltip({
	        html: true,
	        container: '#tag-definition-container',
	        //trigger: 'click',
	        //placement: 'left',
	        title: function() {
				var def;
				var thisTag = $(this).html();
				for (var tag in tagDefs) {
					if (tag.toLowerCase() == thisTag.toLowerCase()) {
						def = tagDefs[thisTag];
						break;
					}
				}
	            return def;
	        }
	    });
    });
	
	//Populate list of song lists that appears on form for adding additional song(s) to an existing song list.
	//TODO: refactor so that hacky app._getSongListsWithStorageLocation() is no longer needed.
	
	//session expiration cleanup; see render:song-lists:view function
	if (!Cookies.get('sharedSongListsSessionStarted')) {
		localStorage.setItem('sharedSongListsThisSession', '{}');
	}
	
	var model = app.model;
	app._getSongListsWithStorageLocation(true).then(function(lists) {
		model.set('_page.songListForm.songLists', lists);
		//Load each of the lists stored in the DB to Derby's model so they can be retrieved
		//synchronously later even if they're not one of the user's own song lists
		//(i.e. a list that was shared with the current user).
		lists.forEach(function(list) {
			if (list._storageLocation == 'db') {
				model.fetch('songLists.' + list.id);
			}
		});
	});
	
	/*
	//Firefox workaround for song lists
	if (navigator.userAgent.indexOf('Firefox') != -1 && determineSongListSaveType(model) == 'session') {
		var songLists = localStorage.getItem('songLists');
		songLists = (songLists ? $.parseJSON(songLists): {});
		var arrSongLists = [];
		for (var id in songLists) {
			list = songLists[id];
			arrSongLists.push(list);
		}
		model.set('_session.songLists', songLists);
		model.set('_page.songListForm.songLists', arrSongLists);
	}
	*/
	
	//WorldCat instructions
	/*
	$('.external-links').on('click', 'a.external-link-worldcat', function(e) {
		e.preventDefault();		

		$('.lnk-find-recordings-scores:first').popover({
			content: 'new content'
		})
		.popover('show');
		
		//$('#worldcat-instructions-popup').modal('show');
	});
	*/
});

app.on('render:song-lists', function(ctx) {
	var model = app.model;
	
	//Workaround for Firefox - load song lists from cookie instead
	//(issue with sessions over HTTPS)
	if (model.get('_page.isFirefox')) {
		if (determineSongListSaveType(model) == 'session') {
			var songListsByName = localStorage.getItem('songLists');
			//var songListsByName = Cookies.get('songLists');
			songListsByName = (songListsByName ? $.parseJSON(songListsByName): {});
			firefox_deleteExpiredSongLists(songListsByName);
			
			//convert the songList map to an array so view bindings will work
			var arrSongLists = [],
				list;
	
			for (var listId in songListsByName) {
				list = songListsByName[listId];
				//use the name as the ID since there's no real songList ID for the free version
				list.id = list.name;
				arrSongLists.push(list);
				
				if (list._prototype=='StaticSongList') {
					//show number of songs in list
					list.details = list.songIds.length + ' song' + (list.songIds.length==1 ? '': 's');
				}
				else {
					list.details = 'auto-updating list; click to see songs';
				}
			}
	
			arrSongLists = sortByKey(arrSongLists, 'name');
			
			model.set('_page.songLists', arrSongLists);
			
			model.set('_session.songLists', songListsByName);
			//also try to save to session on server again in case the session data has been lost
			$.post('/save-song-list', {listJson: JSON.stringify(list)});
		}
		
		$('#songListsContainer').show();
		initShareLinks();
		
		$('#songListsContainer').confirmation({
			selector: '.delete-link',
			onConfirm: function(e) {
				app.songLists.delete(e, this);
			}
		});
	}
	else {
		$('.delete-link').confirmation({
			onConfirm: function(e) {
				app.songLists.delete(e, this);
			}
		});

		initShareLinks();
	}
});

//Firefox workaround
function firefox_deleteExpiredSongLists(songLists) {
	if (!songLists) return;
	
	//expire after 24 hours
	var maxLifetime = 86400000;
	for (var listName in songLists) {
		var list = songLists[listName];
		if (Date.now() - list.timeCreated > maxLifetime) {
			//log('deleting ', listName)
			delete songLists[listName];
		}
	}
	
	localStorage.setItem('songLists', JSON.stringify(songLists));
}

function initShareLinks(isSongListDetailPage) {
	var model = app.model;
	var selector = (isSongListDetailPage ? '#song-list-detail-page': '#song-lists');
	$(selector).on('click', '.share-link', function(e) {
		var listId, list;
		if (isSongListDetailPage) {
			list = model.get('_page.songList');
			listId = list.id;
		}
		else {
			var listId = $(e.target).data('listId');
			var list = getSongListById(listId);
		}
		
		model.set('_page.listIdToShare', listId);
		model.set('_page.listNameToShare', list.name);
		
		//If:
		//1. the user is an individual subscriber, or
		//2. if the user doesn't have permission to edit the list (probably because they weren't the one who created it)
		//
		//...then there's no need to ask the user to email the list to themself; skip to the sharing buttons
		if (model.get('_session.loggedIn')
		  || (isSongListDetailPage && !model.get('_page.hasEditPermission'))
		) {
			//skip the save/email form and show the sharing icons
			$('#save-list-form').hide();
			$('#sharing-section').show();
			app.songLists._showSharingButtons(list.name, listId);
		}
		
		$('#share-modal').modal('show');
	});
	
	$('#share-modal').on('hidden.bs.modal', function (e) {	
		$('#sharing-section').hide();
		$('#save-list-form').show();
		//this will be set to true again if appropriate
		//(need to set it to false here to keep it separate for each list)
		model.set('_page.listEmailedToCreator', false);
	});
	
	function getSongListById(listId) {
		if (determineSongListSaveType(model) == 'session') {
			return model.get('_session.songLists.' + listId);
		}
		else return model.get('songLists.' + listId);
	}
}

//FOR FIREFOX WORKAROUND - CAN BE DELETED LATER
//case-insensitive sort
function sortByKey(arr, key) {
	//type checks are important to prevent the server from crashing in the event of wrong arguments passed
	if (!Array.isArray(arr)) {
		console.error('sortByKey(): first argument must be array');
		return arr;
	}
	if (typeof key != 'string') {
		console.error('sortByKey(): key must be string')
		return arr;
	}
	return arr.sort(function(a, b) {
		a = getSortName(a[key]);
		b = getSortName(b[key]);
		if( a == b) return 0;
		if( a > b) return 1;
		return -1;
	});
	
	function getSortName(name) {
		return name.toLowerCase().replace(/[^\w\s]/g, '');
	}
}

app.on('render:song-lists:view', function(ctx) {	
	var model = app.model;
	var songList = model.get('_page.songList');
	
	//Workaround for Firefox
	if (model.get('_page.songListStoredInSession') && navigator.userAgent.indexOf('Firefox') != -1) {
		var songListsByName = localStorage.getItem('songLists');
		songListsByName = (songListsByName ? $.parseJSON(songListsByName): {});
		var theListId = model.get('_page.songList.id');
		
		var matchFound = false;
		for (var id in songListsByName) {
			if (id == theListId) {
				matchFound = true;
				break;
			}
		}
		
		//if no match was found, it's probably an old list that's still lingering in the _session;
		//redirect
		if (!matchFound) {
			window.location = '/song-lists';
			return;
		}
	}
	
	initShareLinks(true);
		
	//Check for editable shared lists and save to list of song lists
	//that appears when adding additional songs to a list.
	//(The list might have been shared from someone else and opened via a link in an email)
		
	//is it an editable song list created by someone else (or created in a previous anonymous session and then saved)?
	if (songList.editCode && model.get('_page.hasEditPermission') && !model.get('_page.songListStoredInSession')) {
		//TODO
		//It would be better to use the server-side session instead of this combination of
		//localStorage and checking for a cookie. But for now we need something that will
		//work on Firefox as well, and as mentioned in other comments Firefox sessions
		//are currently unreliable.
	
		//if a previous session expired, clear localStorage data.
		//NOTE: this code also runs on the search results page and song detail page,
		//since that's where the dropdown listing the song lists (for adding songs to them) appears.
		if (!Cookies.get('sharedSongListsSessionStarted')) {
			localStorage.setItem('sharedSongListsThisSession', '{}');
		}
	
		//As the user opens editable song lists shared by other users, they get added to the
		//sharedSongListsThisSession array.
		var lists = localStorage.getItem('sharedSongListsThisSession');
		lists = (lists ? JSON.parse(lists): {});
		//songList._storedInSession = model.get('_page.songListStoredInSession');
		lists[songList.id] = songList;
		localStorage.setItem('sharedSongListsThisSession', JSON.stringify(lists));
		Cookies.set('sharedSongListsSessionStarted', '1');
		
		/*
		//songList._temporaryProps.createdInOtherSessionOrAccount = true;
		app._saveSongList(songList, function(err) {
			console.error(err);
		});
		*/
	}
});

app.on('render:song-lists:print', function(ctx) {
	var model = app.model;
	//Remove the song list from the _page model immediately after rendering to free memory
	//and prevent it from slowing down the app
	model.del('_page.songsRaw');
	model.del('_page.songList');
	model.del('_page.commentsBySongId');

	window.print();
});

app.on('render:account:subscribe', function(ctx) {
	//avoid spam by not having the full email address listed anywhere, not even in the JS
	var address = 'subscriptions', domain = 'musicaltheatersongs.com';
	app.model.set('_page.subscriptionsEmailAddress', address + '@' + domain);
});

app.on('render:account:billing', onRenderSubscribeOrRenewPage);
app.on('render:account:renew-subscription', onRenderSubscribeOrRenewPage);
app.on('render:account:subscribe-billing', onRenderSubscribeOrRenewPage);

function onRenderSubscribeOrRenewPage(ctx) {
	var model = app.model;

	//Prevent enter key from submitting the form
	$("#subscribe-form").on("keydown", function(e) {
	   if (e.keyCode === 13) e.preventDefault();
	});

	//avoid spam by not having the full email address listed anywhere, not even in the JS
    var address = 'subscriptions', domain = 'musicaltheatersongs.com';
    model.set('_page.subscriptionsEmailAddress', address + '@' + domain);

	//this is initially hidden to make sure events are bound first;
	//now we're ready to show it
	if (model.get('_page.specialPricing')) {
		$('#show-plan').show();
	}
	else $('#choose-plan').show();

	$('.form-loading').hide();

	//Special or institutional pricing - plan is specified in URL
	var planId = model.get('_page.planId');
	if (planId) {
		//get plan details
		$.getJSON('/subscribe/get-stripe-plan?planId='+planId)
		.done(function(data) {
			var plan = data.plan;
			model.set('_page.plan', plan);
			
			//for institutional plans, multiply the subscription price per user by the quantity specified
			if (planId.indexOf('institutional-')==0) {
				var numUsers = model.get('_page.numUsers');				
				if (numUsers) {
					model.set('_page.totalPrice', (numUsers * plan.amount) / 100);
				}
			}
		})
		.error(function() {
			alert('An internal error occurred retrieving the subscription plan');
		})
	}


    //TODO the prices probably shouldn't be hard-coded here
    var prices = {
        'group-5-10': 69,
        'group-11-20': 65,
        'group-21-plus': 59
    }

	//Update group pricing form when plan field changes
    model.on('all', '_page.planId', function(eventType, planId, oldPlanId) {
        var isGroupPlan = (planId && planId.indexOf('group-')==0);
        model.set('_page.isGroupPlan', isGroupPlan);

        model.set('_page.totalPriceBeforeDiscounts', '$'+prices[planId]);
        $('#total-after-discounts').hide();

        //TODO the below is for institutional pricing
        //For regular group pricing, each user pays for their own account
        /*
        if (isInstitutionalPlan) {
            model.set('_page.showInstitutionalPriceForm', isInstitutionalPlan);

            var groupInfo = planId.split('-');
            var minUsers = groupInfo[1];
            var maxUsers = groupInfo[2];

            model.set('_page.numUsers', minUsers);
            model.set('_page.minUsers', minUsers);
            //100 seems like a reasonable upper limit of users to be purchased using this form
            model.set('_page.maxUsers', (maxUsers == 'plus' ? 100: maxUsers) );

            updateTotalPrice();
        }
        */
    });

	//TODO the below is for institutional pricing
	/*
	//Update total institutional price (validate numUsers first)

	var backspacePressed = false;
	$('#numUsers').on('keydown', function(e) {
		backspacePressed = (e.keyCode == 8);
	});
	$('#numUsers').on('input change', onNumUsersChanged);

	function onNumUsersChanged(e) {
		if (backspacePressed) {
			backspacePressed = false;
			return;
		}

		var planId = model.get('_page.planId');
		var numUsers = $('#numUsers').val();
		if (e.type == 'input') {
			model.set('_page.numUsers', numUsers);
		}

		//Validate that it was an allowed number

        if (e.type=='change' && numUsers == '') {
			//trigger the planId change event to set the numUsers back to the default
            model.set('_page.planId', null);
            model.set('_page.planId', planId);
            return;
        }

		numUsers = parseInt(numUsers);
        if (numUsers > model.get('_page.maxUsers')) {
            model.set('_page.numUsers', parseInt(model.get('_page.maxUsers')));
            updateTotalPrice();
            return;
        }
        if (numUsers < model.get('_page.minUsers')) {
            //we can only check this onChange otherwise it's difficult to type in numbers
            if (e.type == 'change') {
                model.set('_page.numUsers', parseInt(model.get('_page.minUsers')));
				updateTotalPrice();
            }
            return;
        }

        updateTotalPrice();
	}

	//Update total group price
	function updateTotalPrice() {
        var numUsers = model.get('_page.numUsers');
        var planId = model.get('_page.planId');

        //TODO the prices probably shouldn't be hard-coded here
        var prices = {
            'group-5-10': 69,
            'group-11-20': 65,
            'group-21-plus': 59
        }

        var pricePerUser = prices[planId];
        var totalPrice = pricePerUser * numUsers;

        model.set('_page.totalGroupPrice', '$' + totalPrice);
	}
	*/

	//Buggy Derby-only version
	//
    //Update total group price
    /*
    model.on('all', '_page.numUsers', function(eventType, numUsers, oldNumUsers) {
        var planId = model.get('_page.planId'),
            numUsers = model.get('_page.numUsers');

        if (!numUsers) return;

		if (numUsers > model.get('_page.maxUsers')) {
			//moved to jQuery below; not working right
			//model.set('_page.numUsers', model.get('_page.maxUsers'));
			return;
		}
		if (numUsers < model.get('_page.minUsers')) {
            //model.set('_page.minUsers', model.get('_page.minUsers'));
            return;
        }

        //TODO the prices probably shouldn't be hard-coded here
        var prices = {
            'group-5-10': 69,
            'group-11-20': 65,
            'group-21-plus': 59
        }

        var pricePerUser = prices[planId];
        var totalPrice = pricePerUser * numUsers;

        model.set('_page.totalGroupPrice', '$' + totalPrice);
    });
    */

	Stripe.setPublishableKey( model.get('_config.stripe.publishableKey') );

	//TODO find a proper way of doing this with a controller function (see controllers/subscribe.js for my attempt)

	//For the country drop-down on the billing address form: populate states/provinces
	$('#country').change(function() {
	    //Because this function is bound using x-bind change, it seems that the model does not get automatically updated,
	    //so we update it manually
	    //var selectedCountryCode = jQuery(el).val()
	    //model.set('_page.user.address.countryCode', selectedCountryCode);

	    var selectedCountryCode = model.get('_page.user.address.countryCode');

	    //note: for now at least, countryId is same as countryCode
	    var statesQuery = model.query('states', {countryId: selectedCountryCode, $orderby: {name:1}});
	    model.subscribe(statesQuery, function(err) {
	        if (!statesQuery.get()) {
	            model.del('_page.states');
	        }
	        else {
	            statesQuery.ref('_page.states');
	        }
	    });
	})

	//load the list of states/provinces for the initially selected country when the page first loads
	$('#country').trigger('change');
}

app.on('render:subscribe:receipt', function(ctx) {
	//avoid spam by not having the full email address listed anywhere, not even in the JS
    var address = 'subscriptions', domain = 'musicaltheatersongs.com';
    app.model.set('_page.subscriptionsEmailAddress', address + '@' + domain);
});

app.on('render:account', onRenderMyAccountOrMySubscription);
app.on('render:account:subscription', onRenderMyAccountOrMySubscription);
function onRenderMyAccountOrMySubscription(ctx) {
	//avoid spam by not having the full email address listed anywhere, not even in the JS
    var address = 'subscriptions', domain = 'musicaltheatersongs.com';
    app.model.set('_config.emailAddresses.subscriptions', address + '@' + domain);
}

//Close Twitter Bootstrap popovers when clicking outside of them
//http://stackoverflow.com/a/14857326/560114
//
//TODO: Look into possibly making this more generic (i.e. not relying on data-toggle="popover")
//See http://stackoverflow.com/a/24289767/560114
//
function closePopoversOnClickOutside() {
	//only apply to this page
	var bodyClass = $('body').attr('class');

	$('body.'+bodyClass).on('click', function (e) {
	    $('[data-toggle="popover"]').each(function () {
	        //the 'is' for buttons that trigger popups
	        //the 'has' for icons within a button that triggers a popup
	        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
	            $(this).popover('hide');
	        }
	    });
	});
}

app.on('render:privacy', function(ctx) {
	//avoid spam by not having the full email address listed anywhere, not even in the JS
	var address = 'feedback', domain = 'musicaltheatersongs.com';
	app.model.set('_page.contactEmail', address + '@' + domain);
});

app.on('render:contact', function(ctx) {
	//avoid spam by not having the full email addresses listed anywhere, not even in the JS
	var addresses = ['feedback', 'subscriptions', 'webmaster', 'creators'];
	var domain = 'musicaltheatersongs.com';
	var model = app.model;
	addresses.forEach(function(address) {
		model.set('_page.emails.'+address, address + '@' + domain);
	});
});
